import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const listFileService = {
  get_all: async (
    search = "",
    form_date = "",
    to_date = "",
    page,
    limit,
    token,
  ) => {
    const response = await https.get(
      `${API_ROUTES.FILE.GET_ALL}?page=${page}&limit=${limit}&search_value=${search}&from_date=${form_date}&to_date=${to_date}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_by_id: async (id, token) => {
    const response = await https.get(`${API_ROUTES.FILE.GET_BY_ID}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },

  delete: async (id, token) => {
    const response = await https.delete(`${API_ROUTES.FILE.DELETE}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  duplicate_profile: async (profile_id, token) => {
    const response = await https.post(
      `${API_ROUTES.FILE.DUPLICATE}/${profile_id}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_profile_estimate: (token, profileId) => {
    const uri = API_ROUTES.FILE.GET_PROFILE_ESTIMATE.replace(
      ":profileId",
      profileId,
    );
    return https.get(uri, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_estimate_adjustment_history: async (token, profileId, params) => {
    const response = await https.get(
      `${API_ROUTES.FILE.GET_ESTIMATE_ADJUSTMENT_HISTORY.replace(
        ":profileId",
        profileId,
      )}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      },
    );
    return response;
  },
};
